import React, { useEffect, Suspense, lazy } from 'react';
import { StickyTopBar, Hero, SocialProof } from './components/Hero';
import { Benefits, ForYouChecklist, Transition } from './components/Features';
import { CheckoutProvider } from './components/checkout-context';
import { ExitUpsellPopup } from './components/ExitUpsellPopup';
import { PurchaseToast } from './components/PurchaseToast';
import { initPixel, track } from './components/fbpixel';
const KitCatalog = lazy(() => import('./components/KitCatalog').then(m => ({
  default: m.KitCatalog
})));
const Offer = lazy(() => import('./components/Offer').then(m => ({
  default: m.Offer
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Testimonials = lazy(() => import('./components/Checkout').then(m => ({
  default: m.Testimonials
})));
const ValueStack = lazy(() => import('./components/Checkout').then(m => ({
  default: m.ValueStack
})));
const Guarantee = lazy(() => import('./components/Checkout').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/FAQ').then(m => ({
  default: m.Footer
})));
const MobileStickyCTA = lazy(() => import('./components/FAQ').then(m => ({
  default: m.MobileStickyCTA
})));
const SectionFallback = () => <div className="min-h-[200px]" aria-hidden data-id="element-0" />;
export function App() {
  useEffect(() => {
    // Init Meta Pixel + fire PageView, then ViewContent for this product page
    initPixel();
    track('ViewContent', {
      content_name: 'Kit Educativo 15 en 1',
      content_type: 'product',
      currency: 'ARS',
      value: 21999
    });
  }, []);
  return <CheckoutProvider data-id="element-1">
      <div className="min-h-screen font-sans bg-brand-gray selection:bg-brand-pink selection:text-white pb-20 md:pb-0" data-id="element-2">
        <StickyTopBar data-id="element-3" />
        <Hero data-id="element-4" />
        <SocialProof data-id="element-5" />
        <Benefits data-id="element-6" />
        <ForYouChecklist data-id="element-7" />
        <Transition data-id="element-8" />
        <Suspense fallback={<SectionFallback data-id="element-10" />} data-id="element-9">
          <KitCatalog data-id="element-11" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-13" />} data-id="element-12">
          <Offer data-id="element-14" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-16" />} data-id="element-15">
          <Bonuses data-id="element-17" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-19" />} data-id="element-18">
          <Testimonials data-id="element-20" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-22" />} data-id="element-21">
          <ValueStack data-id="element-23" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-25" />} data-id="element-24">
          <Guarantee data-id="element-26" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-28" />} data-id="element-27">
          <FAQ data-id="element-29" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-31" />} data-id="element-30">
          <FinalCTA data-id="element-32" />
        </Suspense>
        <Suspense fallback={<SectionFallback data-id="element-34" />} data-id="element-33">
          <Footer data-id="element-35" />
        </Suspense>
        <Suspense fallback={null} data-id="element-36">
          <MobileStickyCTA data-id="element-37" />
        </Suspense>
        <ExitUpsellPopup data-id="element-38" />
        <PurchaseToast data-id="element-39" />
      </div>
    </CheckoutProvider>;
}